import * as React from "react";

const BookingLayout: React.FC = (props) => {
    return <div className="u-height-100pc u-pos-fixed u-width-100pc">{props.children}</div>;
};

export default BookingLayout;
